/**
 * Positioning and delivery promises that appear in more than one place.
 *
 * These are commitments we make publicly, so they live in one file: change a
 * value here and every page that quotes it stays in sync.
 */
export let delivery = {
  /** How quickly we answer a new inquiry. */
  responseTime: "one business day",
  /** Length of the first call. */
  callLength: "30 minutes",
  /** Shorthand used in button labels. */
  callLabel: "Book a 30-minute call",
  /** Where inquiries land if someone would rather skip the form. */
  email: "contact@bmcreations.dev",
} as const;

/**
 * The delivery timeline, shown in full on the home page and trimmed to the
 * first few steps on the contact page.
 */
export let processSteps = [
  {
    when: "Day 1",
    title: "Intro call",
    description: `${delivery.callLength} with the engineers who would do the work. You walk us through the product, the deadline, and what is actually blocking it.`,
  },
  {
    when: "Day 3",
    title: "Scope and plan",
    description:
      "A written plan: what ships, what gets cut, who does what, and what it costs. Fixed scope, no surprise invoices.",
  },
  {
    when: "Week 1",
    title: "In your repo",
    description:
      "We join your Slack, your standups and your codebase, and merge our first pull request inside the week.",
  },
  {
    when: "Week 2",
    title: "A build in your hands",
    description:
      "A signed build on TestFlight and the Play internal track. From here you see the product every week instead of at the end.",
  },
  {
    when: "Every week",
    title: "Ship and report",
    description:
      "A new build, a short written update and a live backlog every week. Progress you can check, not status theater.",
  },
  {
    when: "Launch",
    title: "Store and handover",
    description:
      "App Store and Play Store submission, release monitoring, and shared code documented so your team can carry it forward.",
  },
] as const;
